<template>
    <section class="section-add-service mb-3">
        <button v-b-modal="modalId" class="btn btn-block btn-primary">{{text}}</button>
        <b-modal :id="modalId"  size="lg" hide-footer>
            <!-- loader -->
            <div v-if="!searchServiceResult" class="jumping-dots-loader">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <b-card v-else class="p-2" no-body>
                <div class="row m-4">
                    <div v-if="allService" class="offset-md-8 col-md-4 col-sm-12 p-0">
                        <div class="input-group">
                            <input v-model="inputSearch"  @keyup="searchService()" class="form-control" id="navbar-search-input" placeholder="Rechercher un service" aria-label="search" aria-describedby="search">
                            <div class="input-group-append">
                                <button type="submit" class="input-group-text"><i class="fa fa-search icon-sm"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Sélectionner prestations version mobile -->
                    <!-- <button class="btn btn-block btn-secondary mt-4 mobile" @click="addService">Ajouter la sélection</button>
                    <button class="btn btn-block btn-outline-dark mt-2 mobile mb-5 mx-0" @click="$bvModal.hide(modalId)">Retour</button> -->

                <!-- affichage Ordinateur -->
                <b-tabs class="computer" pills card vertical nav-wrapper-class="w-50">
                    <b-tab title="Tous" @click="allService =true">
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in searchServiceResult" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-2">{{calculTimes(item.duration)}}</div>
                                    <div class="col-md-2" style="text-align:right">{{item.price}} €</div>
                                    <div class="col-md-2">
                                        <button class="btn btn-social-icon btn-secondary" @click="addTagService(item)"><i class="mdi mdi-plus"></i></button>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                    <b-tab  @click="allService =false" :title="item.category"  v-for="(item, index) in categorie" :key="index" >
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in item.services" :key="index">
                                <div class="row">
                                    <div class="col-md-6">{{item.name}}</div>
                                    <div class="col-md-2">{{calculTimes(item.duration)}}</div>
                                    <div class="col-md-2" style="text-align:right">{{item.price}} €</div>
                                    <div class="col-md-2">
                                        <button class="btn btn-social-icon btn-secondary" @click="addTagService(item)"><i class="mdi mdi-plus"></i></button>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                </b-tabs>

                <!-- affichage mobile -->
                <b-tabs class="mobile tab-solid tab-solid-danger">
                    <b-tab title="Tous" @click="allService =true">
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in searchServiceResult" :key="index">
                                <div class="row">
                                    <div class="col-md-12">{{item.name}}</div>
                                    <div class="col-md-12 d-flex justify-content-between">
                                        <span>
                                            <div>{{calculTimes(item.duration)}}</div>
                                            <div>{{item.price}} €</div>
                                        </span>
                                        <button class="btn btn-secondary btn-rounded btn-icon" @click="fastAddService(item)"><i class="mdi mdi-plus"></i></button>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                    <b-tab  @click="allService =false" :title="item.category"  v-for="(item, index) in categorie" :key="index" >
                        <b-list-group>
                            <b-list-group-item href="#" @click="selectedService = item"  v-for="(item, index) in item.services" :key="index">
                                <div class="row">
                                    <div class="col-md-12">{{item.name}}</div>
                                    <div class="col-md-12 d-flex justify-content-between">
                                        <span>
                                            <div>{{calculTimes(item.duration)}}</div>
                                            <div>{{item.price}} €</div>
                                        </span>
                                        <button class="btn btn-secondary btn-rounded btn-icon" @click="fastAddService(item)"><i class="mdi mdi-plus"></i></button>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                </b-tabs>

                <!-- TAGS: liste des services  -->
                <div class="row mt-4 computer">
                    <div class="col-md-12">
                        <div>
                            <label for="tags-basic">Prestations ajoutées</label>
                            <b-form-tags input-id="tags-basic" v-model="tagServices" size="lg" tag-variant="secondary"
                            placeholder=" " no-outer-focus disable-add-button no-add-on-enter
                            ></b-form-tags>
                        </div>
                    </div>
                </div>
            </b-card>
            <hr>
            <div class="d-flex justify-content-end computer">
                <button class="btn btn-link mx-4" @click="$bvModal.hide(modalId)">Annuler</button>
                <!-- <button class="btn btn-primary mx-4" @click="addService">Sélectionner</button> -->
                <button id="addArrayServices" class="btn btn-primary mx-4" @click="addArrayServices()">VALIDER</button>
            </div>
        </b-modal>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'add-service',
    data () {
        return {
            selectedService: null,
            inputSearch:'',
            searchServiceResult:null,
            allService:true,
            categorie:null,
            services:null,
            tagServices:[]
        }
    },
    props:{
        text:{
            type:String,
            default:"Ajouter un rendez-vous"
        },
        modalId:{
            type:String,
            default:"modal"
        }
    },
    methods:{
        getCategories(){
            let url = "categories"
            axios.get(url)
                .then(
                    resgetcategories => {
                        this.categorie = resgetcategories.data.result
                        this.categorie = this.categorie.filter(element => element.ulid !="01FY46MX2EW85PP30KQ6S9BXG3")
                    }
                )
                .catch(
                    errgetProducts => {
                        console.log(errgetProducts)
                    }
                )
        },
        getService(){
            let url ="services"
            axios.get(url)
                .then(
                    resgetService => {
                        this.services = resgetService.data.result
                        this.services = this.services.filter(service => service.isactive)
                        console.log(this.services);
                        this.searchServiceResult =this.services
                    }
                )
                .catch(
                    errgetProducts => {
                        console.log(errgetProducts)
                    }
                )
        },
        select(item){
            this.selectedService=item
        },
        // ajouter le service dans la liste à ajouter
        addTagService(service){
            this.tagServices.push(service.name)
        },
        // envoyer la liste dans le tableau
        addArrayServices(){
            if(this.tagServices.length !== 0){
                this.$snotify.success("Prestations ajoutées au panier", {
                    timeout: 2000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    });
                let services = this.services.filter(service => this.tagServices.includes(service.name.trim()))
                console.log("services filtrés", services);
                this.$emit('updateService', services)
                this.$bvModal.hide(this.modalId)
                this.tagServices = []
            }else{
                alert('Veuillez sélectionner au moins une prestation')
            }
        },
        fastAddService(item){
            this.selectedService = [item]
            this.addService()
        },
        addService(){   
            if(this.selectedService){
                this.$snotify.success("Prestation ajoutée au panier", {
                    timeout: 2000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    });
                this.$bvModal.hide(this.modalId)
                console.log('selected service', this.selectedService);
                this.$emit('updateService',this.selectedService)
                this.selectedService=null
            }else{
                alert('Veuillez sélectionner une prestation')
            }
        },
        searchService()
        {
            this.searchServiceResult=null
            this.currentPage = 1
            const regex = new RegExp(this.inputSearch.toLowerCase());
            let newservice = []
            // if (this.filtrekey == "") {
            // // newproduct = this.products
            // }
            this.services.forEach(element => {
                if(regex.test(element.name.toLowerCase())){
                    newservice.push(element)
                }
            })
            this.searchServiceResult = newservice
        },
        convertToTime(duration){
            var sec = 3600 * duration
            var date = new Date(0);
            date.setSeconds(sec);
            var timeString = date.toISOString().substr(11, 8);
            return timeString
        },
        calculTimes(floatTime){
            var sec = 3600 * floatTime
            var date = new Date(0);
            date.setSeconds(sec);
            var timeString = date.toISOString().substr(11, 5);
            let heure = Number(timeString.substr(0,2))
            let min = Number(timeString.substr(3,5))
            let stringHeure = ''
            if (heure) {
                stringHeure = heure+ ' h'
            }
            if (min) {
                stringHeure += min + 'mn'
            }
            return stringHeure
        }
    },
    mounted(){
        this.getCategories()
        this.getService()
    }
}
</script>
<style scoped>
::v-deep .tab-pane.active {
    max-height: 50vh;
    overflow: auto;
}
::v-deep .tab-solid-danger .nav-link.active{
    background: #d69c2e;
    color: #fff;
}
::v-deep .nav-pills .nav-link.active, .nav-pills .show > .nav-link{
    background-color: #d69c2e !important;
    color: #fff;
}
::v-deep .list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #ffe6b8;
}

.btn-secondary {
    background: rgb(205, 165, 37);
}
.btn-secondary:hover {
    background: rgb(158, 126, 23);
}
.btn-secondary:focus {
    background: rgb(205, 165, 37);
}

@media screen and (max-width: 992px) {
    .section-add-service{
        width: 100%
    }
}

/* form tag */
::v-deep .b-form-tag{
    background: rgb(50, 50, 50);
    font-size: 16px;
}
/* cacher le bouton add */
::v-deep .b-form-tags-button{
    display: none
}
::v-deep #tags-basic{
    cursor: default;
}
</style>